import { makeStyles, Theme } from '@material-ui/core/styles';
import { red, pink, orange } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  inputTwo: {
    color: 'rgb(0 0 0 / 87%)',
    width: '100%',
    '& .MuiInputBase-input': {
      padding: '18px 6px',
    },
    '& label': {
      transform: 'translate(0, 0)',
      '& + div': {
        margin: 0,
      },
    },
    '& .MuiPhoneNumber-flagButton': {
      marginTop: '15px',
    },
  },
  searchInput: {
    borderRadius: 4,
    width: '100%',
    height: 50,
  },
  noBorder: {
    border: 'none',
  },
  btnAdd: {
    boxShadow: theme.shadows[0],
    padding: theme.spacing(1, 1),
    marginLeft: theme.spacing(2),
    minWidth: 64,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fff',
    '& .MuiInput-underline': {
      '&:before': {
        display: 'none',
      },
      padding: `0 ${theme.spacing(1.5)}px 1px ${theme.spacing(1.5)}px`,
      '&:after': {
        display: 'none',
      },
    },
    '& .MuiInputBase-input': {
      padding: `0 ${theme.spacing(1)}px 1px ${theme.spacing(1)}px`,
      '&::-webkit-input-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
      },
      '&::-moz-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
      },
      '&:-moz-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
      },
      '&:-ms-input-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
      },
    },
  },
  centerHeadBox: {
    flexGrow: 1,
    margin: `0 ${theme.spacing(2)}px`,
  },
  textBox: {
    marginBottom: theme.spacing(2),
    fontSize: 14,
    color: 'rgb(0 0 0 / 54%)',
  },
  dataGrid: {
    width: '100%',
    '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
    '& .MuiDataGrid-root .MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .row-background-error': {
      backgroundColor: red[50],
      '&:hover': {
        backgroundColor: red[100],
      },
    },
    '& .row-background-alert': {
      backgroundColor: pink[50],
      '&:hover': {
        backgroundColor: pink[100],
      },
    },
    '& .row-background-transaction': {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .cell-text-color-error': {
      color: pink[700],
    },
    '& .cell-text-color-alert': {
      color: orange[700],
    },
    '& .cell-text-color-transaction': {
      color: 'black',
      fontWeight: '500',
      textTransform: 'capitalize',
    },
    '& .MuiDataGrid-colCellTitle': {
      color: 'black',
      fontWeight: '700',
      textTransform: 'capitalize',
    },
    marginBottom: '10px',
    padding: '10px',
  },
  leftCol: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '24px',
  },
  search: {
    //margin: theme.spacing(2),
    width: '50%',
  },
  input: {
    width: '100%',
    color: 'rgb(0 0 0 / 87%)',
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  submitBtn: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    whiteSpace: 'nowrap',
    backgroundColor: '#E2222B',
    fontWeight: 500,
    lineHeight: '26px',

    letterSpacing: '0.46px',
    textTransform: 'capitalize',

    color: '#FFFFFF',
  },
  link: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '100px',
    flexGrow: 1,
    fontWeight: 600,
    fontFamily: 'Roboto',
    fontSize: '20px',
    lineHeight: '27px',
  },
  border: {
    border: '1px solid #E0E0E0',
  },
  boxes: {
    width: '80% !important',
  },
  tableCheck: {
    padding: '0 !important',
  },
  cellTitle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  titleLink: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    color: '#5081FF',
    cursor: 'pointer',
  },
  cellLink: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: '#5081FF',
    cursor: 'pointer',
    '& .MuiInputBase-input': {
      color: '#5081FF',
    },
  },
  cellInputLink: {
    '& .MuiInputBase-input': {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      color: '#5081FF',
    },
  },
  row: {
    position: 'relative',
    alignItems: 'center',
  },
  mappingSubText: {
    fontSize: '14px',
    color: '#6b7280', // soft gray
    marginTop: '4px',
  },
  selectBlock: {
    width: '100%',
    padding: theme.spacing(1, 1, 1, 3),
    border: '1px solid #E0E0E0',
    borderRadius: '4px',

    '& > div': {
      background: 'transparent',
    },
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
  },
  selectIcon: {
    marginRight: theme.spacing(1.1),
  },
  mappingHeader: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2, 3),
  },
  mappingTitle: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.87)',
    margin: 0,
    letterSpacing: '0.15px',
  },
}));

export const useStylesSecond = makeStyles((theme: Theme) => ({
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },

  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      padding: theme.spacing(2, 0, 0, 0),
    },
  },
  tabsPanel: {
    padding: 12,
    width: '100%',
  },
  tabsPanels: {
    padding: 24,
    width: '100%',
  },
  tabBox: {
    //backgroundColor: '#ffffff',
    //marginTop: theme.spacing(2.5),
  },
  tab: {
    //backgroundColor: '#ffffff',
    marginTop: theme.spacing(2.5),
  },
  container: {
    width: '100%',
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(3.5),
  },
  titlePopSmtp: {
    width: 170,
    margin: theme.spacing(0, 5, 0, 0),
    color: 'rgb(0 0 0 / 87%)',
  },
  desc: {
    width: 320,
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
  badge: {
    position: 'relative',
    left: theme.spacing(-2),
  },
}));
